import instaIconImg from '@static/media/images/campaign/icon.insta.svg'
import splashBgImg from '@static/media/images/home/splash.bg.png'

export default function CampaignEndPage() {
  return (
    <div className='font-NotoSansCJK items-center flex flex-col pb-[3rem] justify-center w-full h-full relative bg-[url("/static/media/images/home/splash.bg.png")] bg-cover'>
      <div>
        <p
          className={'whitespace-pre-wrap text-white font-[700] text-center text-[2.4rem]'}
        >{`캠페인은 종료되었습니다.\n많은 참여 감사합니다.`}</p>
        <p
          className={'whitespace-pre-wrap text-white font-[400] text-center text-[1.6rem] mt-[2rem]'}
        >{`캠페인 아카이빙은\n인스타그램에서 볼 수 있어요!`}</p>
      </div>

      <button
        className={
          'bg-[#FF61D3] w-[90%] h-[5.8rem] mt-[7rem] rounded-[0.8rem] flex justify-center items-center gap-[1rem] max-w-[33rem]'
        }
        onClick={() => window.open('https://www.instagram.com/goodbye_plastic_seoul', '_blank')}
      >
        <p className={'text-white text-[1.6rem] font-[400]'}>인스타그램에서 확인하기</p>
      </button>
    </div>
  )
}
